module.exports = __webpack_public_path__ + "static/media/life.d99887b7.png";